export enum PermissionEnum {
	ViewUserManagement = "PER_ViewUserManagement",
	ViewUsers = "PER_ViewUsers",
	CreateUsers = "PER_CreateUsers",
	EditUsers = "PER_EditUsers",
	AccessAllFvcSessions = "PER_AccessAllFvcSessions",
	AccessSingleFvcSession = "PER_AccessSingleFvcSession",
	OverreadFvcSession = "PER_OverreadFvcSession",
	AccessAllDlcoSessions = "PER_AccessAllDlcoSessions",
	AccessSingleDlcoSession = "PER_AccessSingleDlcoSession",
	OverreadDlcoSession = "PER_OverreadDlcoSession",
	ViewFixedComments = "PER_ViewFixedComments",
	CreateFixedComment = "PER_CreateFixedComment",
	EditFixedComment = "PER_EditFixedComment",
	SendToCentralisedDataStore = "PER_SendToCentralisedDataStore",
	ReceiveFromCentralisedDataStore = "PER_ReceiveFromCentralisedDataStore",
	ViewAuditTrail = "PER_ViewAuditTrail",
	ViewEDiaryConfigurations = "PER_ViewEDiaryConfigurations",
	CreateEDiaryConfiguration = "PER_CreateEDiaryConfiguration",
	EditEDiaryConfiguration = "PER_EditEDiaryConfiguration",
	DeleteEDiaryConfiguration = "PER_DeleteEDiaryConfiguration",
	ViewStudies = "PER_ViewStudies",
	CreateStudy = "PER_CreateStudy",
	EditStudy = "PER_EditStudy",
	CustomiseStudy = "PER_CustomiseStudy",
	ViewSubjects = "PER_ViewSubjects",
	CreateSubject = "PER_CreateSubject",
	EditSubject = "PER_EditSubject",
	ConnectToDeviceHub = "PER_ConnectToDeviceHub",
	ControlRemoteDevices = "PER_ControlRemoteDevices",
	SendRemoteDeviceFeedback = "PER_SendRemoteDeviceFeedback",
	ViewSites = "PER_ViewSites",
	CreateSite = "PER_CreateSite",
	EditSite = "PER_EditSite",
	ViewAllDiarySessions = "PER_ViewAllDiarySessions",
	AccessIndividualDiaryResults = "PER_ViewSingleDiarySession",
	ViewSiteSubjects = "PER_ViewSiteSubjects",
	CreateSiteSubjects = "PER_CreateSiteSubjects",
	EditSiteSubjects = "PER_EditSiteSubjects",
	ViewDeviceResources = "PER_ViewDeviceResources",
	CreateDeviceResources = "PER_CreateDeviceResources",
	EditDeviceResources = "PER_EditDeviceResources",
	DeleteDeviceResources = "PER_DeleteDeviceResources",
	RequiresEDiaryPin = "PER_RequiresEDiaryPin",
	RequiresSite = "PER_RequiresSite",
	RevealAllSubjectsEDiaryPin = "PER_RevealAllSubjectsEDiaryPin",
	AddFile = "PER_AddFile",
	DeleteFile = "PER_DeleteFile",
	CreateSpirotracUser = "PER_CreateSpirotracUser",
	EditSpirotracUser = "PER_EditSpirotracUser",
	AssociateUsersWithSites = "PER_AssociateUsersWithSites",
	AccessApi = "PER_AccessApi",
	AccessAdmin = "PER_AccessAdmin",
	StudyConfigureDevices = "PER_StudyConfigureDevices",
	ViewRoleManagement = "PER_ViewRoleManagement",
	AlignPermissionsToRoles = "PER_AlignPermissionsToRoles",
	CreateRole = "PER_CreateRole",
	ViewSupportContactInformationAdministration = "PER_ViewSupportContactInformationAdministration",
	ViewFvcSessionsWidget = "PER_ViewFvcSessionsWidget",
	ViewSessionsStatusBreakdownWidget = "PER_ViewSessionsStatusBreakdownWidget",
	ViewDocumentsWidget = "PER_ViewDocumentsWidget",
	EditSupportContactInformationAdministration = "PER_EditSupportContactInformationAdministration",
	AnalyseCoughSessions = "PER_AnalyseCoughSessions",
	ViewReports = "PER_ViewReports",
	ViewAcceptRejectSummaryReport = "PER_ViewAcceptRejectSummaryReport",
	StartSession = "PER_StartSession",
	AddSubjectNotes = "PER_AddSubjectNotes",
	ViewDevices = "PER_ViewDevices",
	AddDevices = "PER_AddDevices",
	AddCoughSessionNotes = "PER_AddCoughSessionNotes",
	AccessHangfire = "PER_AccessHangfire",
	ViewSingleCoughSession = "PER_ViewSingleCoughSession",
	ViewHistoricalCoughSessionReport = "PER_ViewHistoricalCoughSessionReport",
	SendCoughSessionForInterVariabilityReview = "PER_SendCoughSessionForInterVariabilityReview",
	UnassignDevice = "PER_UnassignDevice",
	AccessAllECGSessions = "PER_AccessAllECGSessions",
	ViewSiteDevices = "PER_ViewSiteDevices",
	EditSiteDevices = "PER_EditSiteDevices",
	ViewPopulationGroups = "PER_ViewPopulationGroups",
	EditPopulationGroups = "PER_EditPopulationGroups",
	CreatePopulationGroups = "PER_CreatePopulationGroups",
	AddEcgReports = "PER_AddEcgReports",
	DeletePopulationGroups = "PER_DeletePopulationGroups",
	UploadVitaloJak1Data = "PER_UploadVitaloJak1Data",
	CanPostMedia = "PER_CanPostMedia",
	ResetCoughAnalysis = "PER_ResetCoughAnalysis",
	AssignCoughSession = "PER_AssignCoughAnalysisSet",
	ReopenCoughSession = "PER_ReopenCoughSession",
	CanDesignReports = "PER_CanDesignReports",
	ViewAllReports = "PER_ViewAllReports",
	EditTrackingNumber = "PER_EditTrackingNumber",
	CanChangeWaveform = "PER_CanChangeWaveform",
	CanDeleteAllTags = "PER_CanDeleteAllTags",
	ViewReviewMerged = "PER_ViewReviewMerged",
	ViewAllCoughSessions = "PER_ViewAllCoughSessions",
	SetPostedCoughSessionToReceived = "PER_SetPostedCoughSessionToReceived",
	ViewAlertNotifications = "PER_ViewAlertNotifications",
	AssignAllRoles = "PER_AssignAllRoles",
	UploadVitaloJak2Data = "PER_UploadVitaloJak2Data",
	ImportCoughEvents = "PER_ImportCoughEvents",
	DownloadCoughRecordings = "PER_DownloadCoughRecordings",
	MapServerDirectories = "PER_MapServerDirectories",
	ViewMappedServerDirectories = "PER_ViewMappedServerDirectories",
	ViewStudyProgressWidget = "PER_ViewStudyProgressWidget",
	ViewCoughSessionBreakdownWidget = "PER_ViewCoughSessionBreakdownWidget",
	ImportSites = "PER_ImportSites",
	AccessAllCoughAnalysisSets = "PER_AccessAllCoughAnalysisSets",
	AccessUnassignedCoughAnalysisSets = "PER_AccessUnassignedCoughAnalysisSets",
	AccessAssignedCoughAnalysisSets = "PER_AccessAssignedCoughAnalysisSets",
	OpenAssignedCoughAnalysisSets = "PER_OpenAssignedCoughAnalysisSets",
	ReOpenCoughAnalysisSets = "PER_ReOpenCoughAnalysisSets",
	ViewGeneralSettings = "PER_ViewGeneralSettings",
	ModifyGeneralSettings = "PER_ModifyGeneralSettings",
	ReportServerConnectionSettings = "PER_ReportServerConnectionSettings",
	ForceVitaloJak2Reconfiguration = "PER_ForceVitaloJak2Reconfiguration",
	AccessAllBloodGlucoseSessions = "PER_AccessAllBloodGlucoseSessions",
	AccessAllBloodGlucoseTests = "PER_AccessAllBloodGlucoseTests",
	AccessCoughAnalysisSetsInSessionQA = "PER_AccessAssignedCoughAnalysisSetsInSessionQA",
	AllowMultipleCoughCountsOfCoughAnalysisSets = "PER_AllowMultipleCoughCountsOfCoughAnalysisSets",
	RequestDCF = "PER_RequestDCF",
	AccessDataCorrections = "PER_AccessDataCorrections",
	SiteApproveDataCorrections = "PER_SiteApproveDataCorrections",
	VitalographApproveDataCorrections = "PER_VitalographReviewDataCorrections",
	DataCorrectionApproveImplementation = "PER_DataCorrectionApproveImplementation",
	UploadDcfAttachments = "PER_UploadDcfFileAttachments",
	DownloadDcfAttachments = "PER_DownloadDcfFileAttachments",
	SetPrimaryAnalysisSets = "PER_SetPrimaryAnalysisSets",
	ReProcessCoughSession = "PER_ReprocessCoughSession",
	ViewAnalysisSetHistory = "PER_ViewAnalysisSetHistory",
	AccessAllSites = "PER_AccessAllSites",
	UpdateCoughAnalysisSetReopenReason = "PER_UpdateCoughAnalysisSetReopenReason",
	ImportBaseReports = "PER_ImportBaseReports",
	ViewAllCoughSessionNotes = "PER_ViewAllCoughSessionNotes",
	CreateAQCFvcAnalysisSet = "PER_CreateAQCFvcAnalysisSet",
	CreateLinkedCoughAnalysisSets = "PER_CreateALinkedCoughAnalysisSet",
	RemoveLinkedCoughAnalysisSets = "PER_RemoveALinkedCoughAnalysisSet",
	AccessTrainingPortal = "PER_LinkToTrainingPortal",
	ReImportDeviceEvents = "PER_ReImportDeviceEvents",
	CreateAutomatedQCFvcSelection = "PER_CreateAnAutomatedQCFvcSelection",
	ReviewCoughAnalysisSet = "PER_ReviewCoughAnalysisSet",
	CreateAutomatedQCDlcoSelection = "PER_CreateAnAutomatedQCDlcoSelection",
	UploadIn2itiveDiary = "PER_UploadIn2itiveDiary",
	ViewDiaryTrends = "PER_ViewDiaryTrends",
	ViewOverreaderName = "PER_ViewOverreaderName",
	EditSubjectRandomization = "PER_EditSubjectRandomization",
	CreateFenoSession = "PER_CreateFenoSession",
	EditFenoSession = "PER_EditFenoSession",
	CreateFenoTest = "PER_CreateFenoTest",
	EditFenoTest = "PER_EditFenoTest",
	CreateFenoQC = "PER_CreateFenoQC",
	EditFenoQC = "PER_EditFenoQC",
	AccessAllLungVolumeSessions = "PER_AccessAllLVSessions",
	CreateLungVolumeSession = "PER_CreateLVSession",
	EditLungVolumeSession = "PER_EditLungVolumeSession",
	CreateLungVolumeTest = "PER_CreateLVTest",
	EditLungVolumeTest = "PER_EditLVTest",
	OverreadLungVolumeSession = "PER_OverreadLungVolumeSession",
	AccessSingleLungVolumeSession = "PER_AccessSingleLungVolumeSession",
	RequestMiscDCF = "PER_RequestMiscDCF",
	AddEventOnAnyWaveform = "PER_AddEventOnAnyWaveform",
	AccessSubjects = "PER_AccessSubjects",
	AccessAllMipSessions = "PER_AccessAllMipSessions",
	CreateMipSession = "PER_CreateMipSession",
	EditMipSession = "PER_EditMipSession",
	CreateMipTest = "PER_CreateMipTest",
	EditMipTest = "PER_EditMipTest",
	OverreadMipSession = "PER_OverreadMipSession",
	AccessSingleMipSession = "PER_AccessSingleMipSession",
	AccessAllMepSessions = "PER_AccessAllMepSessions",
	CreateMepSession = "PER_CreateMepSession",
	EditMepSession = "PER_EditMepSession",
	CreateMepTest = "PER_CreateMepTest",
	EditMepTest = "PER_EditMepTest",
	OverreadMepSession = "PER_OverreadMepSession",
	AccessSingleMepSession = "PER_AccessSingleMepSession",
	AccessAllSnipSessions = "PER_AccessAllSnipSessions",
	CreateSnipSession = "PER_CreateSnipSession",
	EditSnipSession = "PER_EditSnipSession",
	CreateSnipTest = "PER_CreateSnipTest",
	EditSnipTest = "PER_EditSnipTest",
	OverreadSnipSession = "PER_OverreadSnipSession",
	AccessSingleSnipSession = "PER_AccessSingleSnipSession",
	CreateAutomatedQcMipSelection = "PER_CreateAnAutomatedQcMipSelection",
	CreateAutomatedQcMepSelection = "PER_CreateAnAutomatedQcMepSelection",
	CreateAutomatedQcSnipSelection = "PER_CreateAnAutomatedQcSnipSelection",
	AccessSingleSvcSession = "PER_AccessSingleSvcSession",
	AccessAllSvcSessions = "PER_AccessAllSvcSessions",
	OverreadSvcSession = "PER_OverreadSvcSession",
	CreateAQCSvcAnalysisSet = "PER_CreateAQCSvcAnalysisSet",
	CreateAutomatedQCSvcSelection = "PER_CreateAnAutomatedQCSvcSelection",
	EarlyTerminateSubject = "PER_EarlyTerminateSubject",
	CreateQcMipAnalysisSet = "PER_CreateQcMipAnalysisSet",
	CreateQcMepAnalysisSet = "PER_CreateQcMepAnalysisSet",
	CreateQcSnipAnalysisSet = "PER_CreateQcSnipAnalysisSet",
	ViewSessionsList = "PER_ViewSessionsList",
	AccessSingleOscillometrySession = "PER_AccessSingleOscillometrySession",
	AccessAllOscillometrySessions = "PER_AccessAllOscillometrySessions",
	OverreadOscillometrySession = "PER_OverreadOscillometrySession",
	ViewOscillometrySessionsWidget = "PER_ViewSOscillometrySessionsWidget",
	CreateAutomatedQCOscillometrySelection = "PER_CreateAnAutomatedQCOscillometrySelection",
	CreateAQCOscillometryAnalysisSet = "PER_CreateAQCOscillometryAnalysisSet",
	OverreadECGSession = "PER_OverreadECGSession",
	AccessSingleECGSession = "PER_AccessSingleECGSession",
	CreateAutomatedQcEcgSelection = "PER_CreateAnAutomatedQcECGSelection",
	ReviewECGSession = "PER_ReviewECGSession",
	AddFvcSessionNotes = "PER_AddFvcSessionNotes",
	AddSvcSessionNotes = "PER_AddSvcSessionNotes",
	AddDiarySessionNotes = "PER_AddDiarySessionNotes",
	AddDlcoSessionNotes = "PER_AddDlcoSessionNotes",
	AddMepSessionNotes = "PER_AddMepSessionNotes",
	AddMipSessionNotes = "PER_AddMipSessionNotes",
	AddSnipSessionNotes = "PER_AddSnipSessionNotes",
	AddOscillometrySessionNotes = "PER_AddOscillometrySessionNotes",
	AddLungVolumeSessionNotes = "PER_AddLungVolumeSessionNotes",
	AddEcgSessionNotes = "PER_AddEcgSessionNotes",
	ViewFvcSessionNotes = "PER_ViewFvcSessionNotes",
	ViewSvcSessionNotes = "PER_ViewSvcSessionNotes",
	ViewDiarySessionNotes = "PER_ViewDiarySessionNotes",
	ViewDlcoSessionNotes = "PER_ViewDlcoSessionNotes",
	ViewMepSessionNotes = "PER_ViewMepSessionNotes",
	ViewMipSessionNotes = "PER_ViewMipSessionNotes",
	ViewSnipSessionNotes = "PER_ViewSnipSessionNotes",
	ViewOscillometrySessionNotes = "PER_ViewOscillometrySessionNotes",
	ViewLungVolumeSessionNotes = "PER_ViewLungVolumeSessionNotes",
	ViewEcgSessionNotes = "PER_ViewEcgSessionNotes",
	ViewSubjectNotes = "PER_ViewSubjectNotes",
	SiteReviewFvcSession = "PER_SiteReviewFvcSession",
	CreateNotificationSubscription = "PER_CreateNotificationSubscription",
	EditNotificationSubscription = "PER_EditNotificationSubscription",
	ViewNotificationSubscriptions = "PER_ViewNotificationSubscriptions",
    ManageCustomCalculations = "PER_ManageCustomCalculations",
    OverreadPefSession = "PER_OverreadPefSession",
    AccessSinglePefSession = "PER_AccessSinglePefSession",
    CreateAQCPefAnalysisSet = "PER_CreateAQCPefAnalysisSet",
    AddPefSessionNotes = "PER_AddPefSessionNotes",
    ViewPefSessionNotes = "PER_ViewPefSessionNotes",
    CreateAutomatedQcPefSelection = "PER_CreateAnAutomatedQcPEFSelection",
	RevealQcLayerDuringCoughAnalysisQa = "PER_RevealQcLayerDuringCoughAnalysisQa",
    AccessSingleSurveySession = "PER_AccessSingleSurvey",
    ViewSurveySessionNotes = "PER_ViewSurveySessionNotes",
    AccessAssistekPortal = "PER_LinkToAssisTekPortal",
}
